
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BoardCategory } from '@/types/board';

interface CategoryTabsProps {
  categories: BoardCategory[];
  activeCategory: BoardCategory;
  setActiveCategory: (category: BoardCategory) => void;
  children: React.ReactNode;
}

const CategoryTabs = ({ 
  categories, 
  activeCategory, 
  setActiveCategory,
  children 
}: CategoryTabsProps) => {
  return (
    <Tabs 
      defaultValue={activeCategory} 
      className="w-full" 
      onValueChange={(value) => setActiveCategory(value as BoardCategory)}
    >
      <TabsList className="grid grid-cols-3 md:grid-cols-6 mb-8 bg-muted">
        {categories.map(category => (
          <TabsTrigger 
            key={category} 
            value={category}
            className="data-[state=inactive]:bg-muted"
          >
            {category}
          </TabsTrigger>
        ))}
      </TabsList>
      {children}
    </Tabs>
  );
};

export default CategoryTabs;
